<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-xl">
        <div class="card" >
          <div class="card-header">
            <div class="container dp-header">
              <div class="header-container">
                <div id="headtext2">{{ getKpiGroupOverallKpiName }}</div>
                <performanceItem  id="headkpi"
                                  :overallByWave="getOverallByWave"
                                  :kpi="getKpiGroupOverall" />
              </div>
            </div>
          </div>

          <div class="card-body">
            <table class="dashtable">
              <tr>
                <td class="tdct row-he" style="top: 0px; vertical-align: top;">
                  <RotatedHeader  v-if="isDigitalChecksSurvey" kpiHeight="91px" totalHeight="700px" />
                  <RotatedHeader  v-else-if="isPreOwnedSurvey" kpiHeight="91px" totalHeight="560px" />
                  <RotatedHeader  v-else-if="this.selection.Surveys.ExternalSurveyId == 1089" kpiHeight="91px" totalHeight="700px" />
                  <RotatedHeader  v-else-if="this.selection.Surveys.ExternalSurveyId == 1086" kpiHeight="91px" totalHeight="992px" />
                  <RotatedHeader  v-else-if="this.selection.Surveys.ExternalSurveyId == 1090 || this.selection.Surveys.ExternalSurveyId == 1091" 
                                  kpiHeight="91px" totalHeight="510px" />
                  <RotatedHeader  v-else />
                </td>

                <td class="tdct row-pe">
                  <LamboDigitalChecksColumn   v-if="isDigitalChecksSurvey" 
                                              :dashdata="dashdata" />
                  <LamboPreOwnedColumn        v-else-if="isPreOwnedSurvey" 
                                              :dashdata="dashdata" />
                  <LamboAfterSalesColumn      v-else-if="this.selection.Surveys.ExternalSurveyId == 1089" 
                                              :survey="this.selection.Surveys.ExternalSurveyId" 
                                              :dashdata="dashdata" />
                  <LamboAfterSalesColumn      v-else-if="this.selection.Surveys.ExternalSurveyId == 1086" 
                                              :survey="this.selection.Surveys.ExternalSurveyId" 
                                              :dashdata="dashdata" />
                  <LamboDigitalColumn         v-else-if="this.selection.Surveys.ExternalSurveyId == 1090 || this.selection.Surveys.ExternalSurveyId == 1091" 
                                              :survey="this.selection.Surveys.ExternalSurveyId" 
                                              :dashdata="dashdata" />
                  <LamboProcessExcellenceColumn v-else :dashdata="dashdata" />
                </td>

                <td class="tdct row-ct">
                  <LamboCustomerTreatmentColumn :dashdata="dashdata" :survey="this.selection.Surveys.ExternalSurveyId * 1" />
                </td>
              </tr>
              
              <tr v-if="isPreOwnedSurvey">
                <td class="tdct row-he" style="top: 0px; vertical-align: top;">
                  <RotatedHeader kpiHeight="91px" totalHeight="500px" />
                </td>

                <td class="tdct row-pe">
                  <LamboPreOwnedColumn2 :dashdata="dashdata" />
                </td>

                <td class="tdct row-ct">

                </td>
              </tr>

              <tr>
                <td colspan="3">
                  <div id="customerjourney">{{$t('Webportal.Dashboard.CustomerJourney')}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl">
        <div class="recommendcontainer">
          <div class="commentrecommend">
            <CommentItem v-if="false" :questionText="getRecommendationQuestionText()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting';
  import PerformanceItem from '@/components/Dashboard-lambo/PerformanceItem';
  import LamboDigitalChecksColumn from '@/components/Dashboard-lambo/LamboDigitalChecksColumn';
  import LamboPreOwnedColumn from '@/components/Dashboard-lambo/LamboPreOwnedColumn';
  import LamboPreOwnedColumn2 from '@/components/Dashboard-lambo/LamboPreOwnedColumn2';
  import LamboProcessExcellenceColumn from '@/components/Dashboard-lambo/LamboProcessExcellenceColumn';
  import LamboCustomerTreatmentColumn from '@/components/Dashboard-lambo/LamboCustomerTreatmentColumn';
  import LamboDigitalColumn from '@/components/Dashboard-lambo/LamboDigitalColumn';
  import RecommendationTable from './RecommendationTable';
  import CommentItem from './CommentItem';
  import RotatedHeader from './RotatedHeader';
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    name: 'DashboardPanel',

    mixins: [ CustomKpiSorting, KpiMixin ],

    props:[
      'selection'
    ],

    components:{
      PerformanceItem,
      LamboPreOwnedColumn,
      LamboPreOwnedColumn2,
      LamboDigitalChecksColumn,
      LamboProcessExcellenceColumn,
      LamboCustomerTreatmentColumn,
      LamboDigitalColumn,
      RecommendationTable,
      CommentItem,
      RotatedHeader
    },

    methods:{

      getText(key) {
        return this.$t('Webportal.Dashboard.' + key);
      },

      getTextRecommend() {
        return this.$t('Webportal.Dashboard.NetPromoterScore');
      },

      getOverallRecommendation() {
        if (this.dashdata && this.dashdata.Recommendation && _.size(this.dashdata.Recommendation) > 0)
          return this.dashdata.Recommendation[0]
      },

      getRecommendationQuestionText() {
        let rec = this.getOverallRecommendation();
        if (!rec) {
          return '';
        }
        return rec.QuestionText;
      }
    },

    computed: {
      isDigitalChecksSurvey: function() {
        return this.selection.Surveys.ExternalSurveyId == 1077 ||
          this.selection.Surveys.ExternalSurveyId == 1078;
      },

      isPreOwnedSurvey() {
        return this.selection.Surveys.ExternalSurveyId == 1087
            || this.selection.Surveys.ExternalSurveyId == 1088;
      },

      isAfterSalesSurvey() {
        return this.selection.Surveys.ExternalSurveyId == 1086 
            || this.selection.Surveys.ExternalSurveyId == 1089;
      },

      getKpiGroupOverall: function() {
        return this.getKpiGroupByString('00. Overall')
      },

      getKpiGroupOverallOrdered: function() {
        let item = this.getKpiGroupByString('00. Overall');
        return this.getOrderedKpi(item);
      },

      getKpiGroupOverallKpiName: function() {
        var item = this.getKpiGroupOverall;
        if (item) {
          return item.KpiName
        }
      },

      isKpiGroupOverallVisible: function () {
        var _kpi = this.getKpiGroupOverall
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      hasDashdata: function () {
        return _.isEmpty(this.dashdata);
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .recommendcontainer {
    display: flex;
    flex-direction: row;
  }

  .recommendation {
    min-width: 360px;
  }

  .commentrecommend {
    flex-grow: 1;
  }

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: $lambo-black;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .header-container {
    width: 800px;
    padding-right: 0px;
    padding-left: 0px;
    height: 38px;
  }

  #customerjourney {
    width: 96%;
    height: 40px;
    position: relative;
    background: $lambo-journey-color;
    margin: 4px;
    text-align: center;
    color:$lambo-white;
    font-size: 18pt;
  }

  #customerjourney:before {
    content: "";
    position: absolute;
    right: -40px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 40px solid $lambo-journey-border;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
   }

  .tdct
  {
     margin:0px;
     padding: 0px;
     margin-right: 0px;
  }

  .dashtable {
    table-layout: fixed;
    width: 100%;
    margin-inline-start: 1px;
    margin-block-start: -2px;
  }

  .dashtable td {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .row-he {
    width: 31px;
    vertical-align: top;
  }
  .row-pe {
    vertical-align: top;
  }

  .row-ct {
    width: 17%;
    vertical-align: top;
  }

  .dp-header{
    width: 750px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-header:first-child {
      border-radius: 0rem;
      margin: 0px;
      padding: 0px;
  }

  .card-header{
    background: $lambo-header-color;
    height: 40px;
    margin: 0px;
    padding: 0px;
  }

  .card{
    border: solid $lambo-header-border;
    border-width: 2px;
    border-radius: 0rem;
    margin-left: 0px;
  }

  .card-body {
    padding: 0px;
    margin-left: 0px;
    margin-top: 2px;
  }
</style>
